import ResponsibleConsumptionService from 'src/modules/responsibleConsumption/responsibleConsumptionService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'RESPONSIBLECONSUMPTION_VIEW';

const responsibleConsumptionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,
  FIND_RESET: `${prefix}_FIND_RESET`,

  reset: () => async (dispatch) => {
    dispatch({
      type: responsibleConsumptionViewActions.FIND_RESET,
    });
  },

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: responsibleConsumptionViewActions.FIND_STARTED,
      });

      const record = await ResponsibleConsumptionService.find(id);

      dispatch({
        type: responsibleConsumptionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: responsibleConsumptionViewActions.FIND_ERROR,
      });

      navigateTo('/library/responsible-consumption');
    }
  },
};

export default responsibleConsumptionViewActions;
